import React from 'react';
import PropTypes from 'prop-types';

/**
 * Reusable button component
 * @param {Object} props
 * @param {string} props.type - Button type ('button', 'submit')
 * @param {string} props.variant - Bootstrap variant ('primary', 'secondary', etc.)
 * @param {string} [props.className] - Additional classes
 * @param {React.ReactNode} props.children - Button content
 * @param {Object} props.rest - Other props (onClick, disabled, etc.)
 */
function Button({
  type = 'button',
  variant = 'primary',
  className = '',
  children,
  ...rest
}) {
  return (
    <button
      type={type}
      className={`btn btn-${variant} ${className} animate__animated animate__pulse animate__faster`}
      {...rest}
    >
      {children}
    </button>
  );
}

Button.propTypes = {
  type: PropTypes.oneOf(['button', 'submit', 'reset']),
  variant: PropTypes.oneOf([
    'primary',
    'secondary',
    'success',
    'danger',
    'warning',
    'info',
  ]),
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export default Button;